type Props = () => string;

const getYear: Props = () => {
  let date = new Date();
  return date.getFullYear().toString();
};

export default getYear;
